import React from "react";
import { Form } from "react-bootstrap";
import { RequiredMark } from "../FormFields";

interface VersionFieldProps {
  controlId: string;
  label: string;
  placeholder: string;
  value: string | undefined;
  onChange: (value: string) => void;
  pattern?: RegExp;
  invalidMessage?: string;
  required?: boolean;
  className?: string;
}

export function VersionField({
  controlId,
  label,
  placeholder,
  value,
  onChange,
  pattern,
  invalidMessage,
  required = true,
  className,
}: VersionFieldProps) {
  const isInvalid = !!(pattern && value && !pattern.test(value));
  return (
    <Form.Group controlId={controlId} className={className}>
      <Form.Label>
        {label} {required && <RequiredMark />}
      </Form.Label>
      <Form.Control
        type="text"
        size="sm"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        isInvalid={isInvalid}
      />
      {invalidMessage && (
        <Form.Control.Feedback type="invalid">{invalidMessage}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
}

interface Md5FieldProps {
  controlId: string;
  label: string;
  value: string | undefined;
}

export function Md5Field({ controlId, label, value }: Md5FieldProps) {
  return (
    <Form.Group controlId={controlId}>
      <Form.Label>{label}</Form.Label>
      <Form.Control type="text" size="sm" value={value} readOnly />
    </Form.Group>
  );
}
